import axios from "axios";
import { API_URL } from "../../utils/DomainUtils";
import {
  isLoginForbidden,
  showAccessDeniedToast,
} from "../../utils/accessDenied";

//API for all other calls
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Presigned S3 URLs are pre-authorised, so they must not carry our baseURL,
// credentials or Authorization header. They get their own instance rather than
// bare axios so that they pick up the shared error handling below.
export const s3Api = axios.create();

// defining a custom error handler for all APIs
const errorHandler = error => {
  const statusCode = error.response?.status;

  // A 403 from POST /login sends the user to the access-denied page, so a
  // toast repeating the same message on top of it would only be noise.
  if (statusCode === 403 && !isLoginForbidden(error)) {
    showAccessDeniedToast();
  }

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.log(error);
  }

  return Promise.reject(error);
};

// registering the custom error handler to the
// "api" and "s3Api" axios instances
api.interceptors.response.use(undefined, error => {
  return errorHandler(error);
});

s3Api.interceptors.response.use(undefined, error => {
  return errorHandler(error);
});
